import { render, staticRenderFns } from "./Drivers.vue?vue&type=template&id=506aaaee&scoped=true"
import script from "./Drivers.vue?vue&type=script&lang=ts"
export * from "./Drivers.vue?vue&type=script&lang=ts"
import style0 from "./Drivers.vue?vue&type=style&index=0&id=506aaaee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506aaaee",
  null
  
)

export default component.exports